module.exports = __webpack_public_path__ + "img/47.5ce44a59.jpg";